import { Navigate, Route, Routes } from 'react-router-dom';
import { isAuthenticated } from './auth/session';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import DashboardPage from './pages/DashboardPage';
import PayrollLayout from './pages/PayrollLayout';
import PeTenantsPage from './pages/engine/PeTenantsPage';
import PeTenantDetail from './pages/engine/PeTenantDetail';
import {
  PeCasesPage,
  PeLogsPage,
  PePayrunsPage,
  PeRegulationsPage,
  PeReportsPage,
  PeTasksPage,
} from './pages/engine/PeAreaPages';
import RequireAuth from './auth/RequireAuth';
import AuthGate from './auth/AuthGate';

export default function App() {
  return (
    <AuthGate>
      <Routes>
        <Route path="/" element={isAuthenticated() ? <Navigate to="/app" replace /> : <LandingPage />} />
        <Route path="/login" element={isAuthenticated() ? <Navigate to="/app" replace /> : <LoginPage />} />
        <Route path="/signup" element={isAuthenticated() ? <Navigate to="/app" replace /> : <SignupPage />} />
        <Route
          path="/app"
          element={(
            <RequireAuth>
              <PayrollLayout />
            </RequireAuth>
          )}
        >
          <Route path="tenants/:tenantId" element={<PeTenantDetail />} />
          <Route path="tenants" element={<PeTenantsPage />} />
          <Route path="regulations" element={<PeRegulationsPage />} />
          <Route path="cases" element={<PeCasesPage />} />
          <Route path="pe-payruns" element={<PePayrunsPage />} />
          <Route path="reports" element={<PeReportsPage />} />
          <Route path="tasks" element={<PeTasksPage />} />
          <Route path="logs" element={<PeLogsPage />} />
          <Route index element={<DashboardPage />} />
          <Route path="*" element={<DashboardPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthGate>
  );
}
